"use client";

import { ShieldPlus, RotateCcw } from "lucide-react";

export default function GlobalError({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="uk">
      <body
        style={{ fontFamily: "'IBM Plex Sans', system-ui, sans-serif" }}
        className="bg-background text-foreground"
      >
        <div className="flex min-h-screen items-center justify-center px-4">
          <div className="w-full max-w-md text-center">
            <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-primary/10">
              <ShieldPlus className="h-8 w-8 text-primary" />
            </div>

            <h1 className="text-xl font-semibold tracking-tight">
              Something went wrong
            </h1>

            <p className="mx-auto mt-3 max-w-sm text-sm leading-relaxed text-muted-foreground">
              An unexpected error occurred. Please try again.
            </p>

            <button
              type="button"
              onClick={reset}
              className="mt-8 inline-flex items-center gap-2 rounded-lg bg-primary px-5 py-2.5 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90"
            >
              <RotateCcw className="h-4 w-4" />
              Try again
            </button>
          </div>
        </div>
      </body>
    </html>
  );
}
